jQuery(function () {
	jQuery('.js-accordion').accordion();
});
